import { render } from "./Pessoas.vue?vue&type=template&id=bd23ac58&scoped=true"
import script from "./Pessoas.vue?vue&type=script&lang=js"
export * from "./Pessoas.vue?vue&type=script&lang=js"

import "./Pessoas.vue?vue&type=style&index=0&id=bd23ac58&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd23ac58"]])

export default __exports__